export default "__VITE_ASSET__DjTEi84$__"